import { TZDateMini } from '@date-fns/tz';
import { useEffect } from 'react';

import type { TimeValue } from '@dynatrace-sdk/units/types/packages/util/units/src/util-format/time.js';
import { getTimezone } from '@dynatrace-sdk/user-preferences';

import { getStratoLogger } from '../../../core/sdk/sdk-logger.js';

/**
 * Hook to check and log when the min is larger than the max.
 * @internal
 */
export const useMinMaxLogger = (
  min?: TimeValue | null,
  max?: TimeValue | null,
  componentName?: string,
) => {
  const logger = getStratoLogger(
    componentName ?? 'Date Component - MinMaxLogger',
  );

  const timezone = getTimezone();

  useEffect(() => {
    if (
      min &&
      max &&
      new TZDateMini(min.absoluteDate, timezone).getTime() >=
        new TZDateMini(max.absoluteDate, timezone).getTime()
    ) {
      logger.error(
        `Min prop is larger than the max prop. Min: ${min.value}, Max: ${max.value}`,
      );
    }
  }, [min, max, logger, timezone]);
};
